export default {
  state: {},
}